export enum ChartColor {
    YELLOW = "yellow",
    ORANGE = "orange",
    LIGHTGRAY = "lightgray",
    DARKGRAY = "darkgray",
}
